export function transformAdloxUrl(url: string, name: string): string {
  const isPixel = ['click_audit_pixel', 'pixel', 'pixel_additional', 'pixel_additional2'].includes(name);
  const isLink = name === 'link';
  
  // Если не Adlox или не link/pixel поле - возвращаем как есть
  if (!url.includes('pixel.adlooxtracking.ru') || (!isLink && !isPixel)) {
    return url;
  }
  
  // Для link поля - без изменений
  if (isLink) {
    return url;
  }
  
  // Для pixel поля - заменяем ~RANDOM~ на {RND}
  if (isPixel) {
    // Заменяем параметр _=~RANDOM~ на _={RND}
    return url.replace(/_=~RANDOM~/g, '_={RND}');
  }
  
  return url;
}